import React from 'react';

import { PropertyTextInput } from '@paragon/client-tools';
import { PropertiesPanel } from '@paragon/layout-models';

import { getActiveComponentDesignGuid } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { getSingleSelectedItemEntryOrNull } from '../../../../store/selectors/getSelectedItemSelector';
import { updateGusset } from '../../../../store/slices/componentDesignsSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export function GussetProperties() {
  const dispatch = useAppDispatch();
  const selectedEntry = useAppSelector(getSingleSelectedItemEntryOrNull);
  const activeComponentDesignGuid = useAppSelector(getActiveComponentDesignGuid);

  if (selectedEntry?.type !== 'gusset' || !activeComponentDesignGuid) return null;

  const gusset = selectedEntry.item;

  return (
    <PropertiesPanel title="Gusset Properties">
      <PropertyTextInput
        property="Material"
        value={gusset.material}
        submit={(material) =>
          void dispatch(
            updateGusset({
              componentDesignGuid: activeComponentDesignGuid,
              gusset: { ...gusset, material },
            }),
          )
        }
      />
    </PropertiesPanel>
  );
}
